import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../../../core';
import { CidadeSubRegiao } from '../../../../cidade/sub-regiao/cidade-sub-regiao';

@Injectable({
    providedIn: 'root'
})
export class RegiaoCidadeSubRegiaoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/regiao-sub-regiao`
    }

    /** Pesquisa as sub-regiões disponíves para os representantes na cidade informada */
    searchDisponiveisParaRepresentantes(idsRepresentantes: number[], idCidade: number): Observable<CidadeSubRegiao[]> {
        // Params
        let params = new HttpParams();

        // Representantes
        if (idsRepresentantes?.length > 0) {
            idsRepresentantes.forEach(idRepresentante => {
                if (idRepresentante) {
                    params = params.append('idRepresentante', idRepresentante.toString());
                }
            });
        }
        // Cidade
        if (idCidade) {
            params = params.append('idCidade', idCidade.toString());
        }

        return this.customHttp.get<CidadeSubRegiao[]>(`${this.pathApi}/representante/disponiveis`, {params});
    }
}
